import { Suspense } from 'react';
import type { ReactNode } from 'react';
import { LoadingSpinner } from './LoadingSpinner';

interface LazyLoadProps {
  children: ReactNode;
}

export function LazyLoad({ children }: LazyLoadProps) {
  return <Suspense fallback={<LoadingSpinner fullPage />}>{children}</Suspense>;
}
